export default __webpack_public_path__ + "static/media/bg-gradient-3.35a19333.jpg";